import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/dist/css/splide.min.css';

document.addEventListener('DOMContentLoaded', function () {
  // Basic slider
  const basicSliders = document.querySelectorAll('.basic-slider');
  if (basicSliders.length) {
    basicSliders.forEach(function (element) {
      new Splide(element, {
        type: 'loop',
        pagination: true,
        gap: '30px',
        width: '100%',
        arrows: true,
        clones: 5
      }).mount();
    });
  }

  // History slider
  const historySliders = document.querySelectorAll('.history-slider');
  if (historySliders.length) {
    historySliders.forEach(function (element) {
      new Splide(element, {
        padding: '5rem',
        pagination: false,
        perPage: 1,
        arrows: true,
      }).mount();
    });
  }

  // Slideshow
  const slideshows = document.querySelectorAll('.slideshow');
  if (slideshows.length) {
    slideshows.forEach(function (element) {
      new Splide(element, {
        type: 'loop',
        arrows: true,
        gap: '30px',
        pagination: true,
      }).mount();
    });
  }

  // Newsticker
  const newstickerElement = document.querySelector('#newsticker');
  if (newstickerElement) {
    new Splide(newstickerElement, {
      type: 'loop',
      perPage: 3,
      autoScroll: {
        speed: 0.7, 
      },
      pagination: false,
      arrows: false,
      clones: 10,
      pauseOnHover: false,
      pauseOnFocus: false,
    }).mount({ AutoScroll });
  }
});
